import React from "react"
import Results from "../components/Results"
import { graphql } from "gatsby"
import resultsJson from "../../results/2025/data/results.json"

export const query = graphql`
  {
    allMdx(
      sort: { fields: frontmatter___position, order: ASC }
      filter: { fileAbsolutePath: { regex: "/2025/" } }
    ) {
      edges {
        node {
          body
          id
          frontmatter {
            position
            title
          }
        }
      }
    }
  }
`

const Results2025 = ({ data }) => {
  console.log('Results 2025', data, resultsJson)
  return <Results data={data} year={2025} results={resultsJson.results} />
}

export default Results2025;

// import React from "react"
// import Home from "../components/Home"
// import { Layout } from "../components/Layout"

// const IndexPage = () => {
//   return (
//     <Layout>
//       <Home />
//     </Layout>
//   )
// }

// export default IndexPage
